import { create } from 'zustand';

type BoostPlan = {
  data: any;
  setBoostPlanData: (data: object) => void;
};

export const useBoostedPlanDataStore = create<BoostPlan>((set, get) => ({
  data: {},
  setBoostPlanData: data => {
    set(() => ({ data: data }));
  },
  action: () => {
    const data = get().data;
    // ...
  },
}));
